import { createAsyncThunk } from '@reduxjs/toolkit';

export const fetchNews = createAsyncThunk(
  'news/fetchNews',
  () => {
    return fetch(`${process.env.APP_URL}/api/extension-news`)
      .then(async (res) => res.json())
      .catch((err) => {
        console.error('News', err);
        return null;
      });
  }
);
